(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('recall-status', {
            parent: 'entity',
            url: '/recall-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.recall_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/recall-status/recall-statuses.html',
                    controller: 'Recall_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('recall_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('recall-status-detail', {
            parent: 'entity',
            url: '/recall-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.recall_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/recall-status/recall-status-detail.html',
                    controller: 'Recall_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('recall_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Recall_status', function($stateParams, Recall_status) {
                    return Recall_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'recall-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('recall-status-detail.edit', {
            parent: 'recall-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-dialog.html',
                    controller: 'Recall_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Recall_status', function(Recall_status) {
                            return Recall_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('recall-status.new', {
            parent: 'recall-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-dialog.html',
                    controller: 'Recall_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('recall-status', null, { reload: 'recall-status' });
                }, function() {
                    $state.go('recall-status');
                });
            }]
        })
        .state('recall-status.edit', {
            parent: 'recall-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-dialog.html',
                    controller: 'Recall_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Recall_status', function(Recall_status) {
                            return Recall_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('recall-status', null, { reload: 'recall-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('recall-status.delete', {
            parent: 'recall-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-delete-dialog.html',
                    controller: 'Recall_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Recall_status', function(Recall_status) {
                            return Recall_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('recall-status', null, { reload: 'recall-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
